import { render } from "./ForbiddenNameForm.vue?vue&type=template&id=cd7fdf32"
import script from "./ForbiddenNameForm.vue?vue&type=script&lang=js"
export * from "./ForbiddenNameForm.vue?vue&type=script&lang=js"

import "./ForbiddenNameForm.vue?vue&type=style&index=0&id=cd7fdf32&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__